import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DocumentBehaviorService } from 'src/app/services/behavior/document-behavior.service';
import { ToastBehaviorService } from 'src/app/services/behavior/toast-behavior.service';
import { SignatureService } from 'src/app/services/signature-service/signature.service';
import { Any, GetDocument, Subscriber } from 'src/app/shared/models/signature.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Signer } from 'src/app/shared/models/signer';
import { SignatureHistory } from 'src/app/shared/models/signature-history';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SignUpModalComponent } from './components/sign-up-modal/sign-up-modal.component';
import { BaseComponent } from 'src/app/components/base-component';
import { UserService } from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';



declare var $: any;

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
})
export class SignatureComponent extends BaseComponent implements OnInit {

  uidDoc: string = '';
  uidSigner: string = '';
  uidSigned: string = '';
  email: string = '';
  documentName: string = ''
  documentUrl: string = ''
  documentUrlMobile: string = ''
  downloadLink = ''

  loading = true

  srcData?: SafeResourceUrl;

  signerList: Subscriber[] = []
  subscriber?: Subscriber;

  signerHistory: SignatureHistory[] = []

  modalResult?: any

  mobileShowSignForm = false
  valueFormMobile?: any;
  canDownload = false

  sortOrders: string[] = ["Year", "Title", "Author"];
  selectedSortOrder: string = "Sort by...";

  ChangeSortOrder(newSortOrder: string) {
    this.selectedSortOrder = newSortOrder;
  }


  constructor(
    private readonly signatureService: SignatureService,
    private readonly actRoute: ActivatedRoute,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router
  ) {super();}

  ngOnInit(): void {
    sessionStorage.setItem('document', this.actRoute.snapshot.params.uidDoc)
    this.uidDoc = this.actRoute.snapshot.params.uidDoc
    this.uidSigner = this.actRoute.snapshot.params.uidSigner

    this.signatureService.getDocument(this.uidDoc, this.uidSigner).subscribe((res: GetDocument) => {
      if (res) {
        

        this.uidSigned = res.dto.uidSigned
        
        if(res.dto.subscriber.type === '4') {
          res.dto.subscriber.type = 'parte';
        }
        if(res.dto.subscriber.type === '5') {
          res.dto.subscriber.type = 'testemunha';          
        }

        this.subscriber = res.dto.subscriber

        if(res.dto.subscriber.signed) {
          this.canDownload = true
        }

        this.documentName = res.dto.file.name;
        this.documentUrl = res.dto.file.file + '#toolbar=0&navpanes=0&scrollbar=0';
        this.documentUrlMobile = this.documentUrl;
        //this.documentUrlMobile = 'https://docs.google.com/gview?embedded=true&url=' + res.dto.file.file;
        //alert(this.documentUrlMobile);
        this.downloadLink = res.dto.file.file
        
        for (let hist of res.dto.historic) {
          if (hist.signed) {
            if(hist.type === '4') {
              hist.type = 'parte';
            }
            if(hist.type === '5') {
              hist.type = 'testemunha';          
            }
            let newDate = hist.date.split(' ');
            this.signerHistory.push(
              {
                date: newDate[0],
                hour: newDate[1],
                signer: hist
              }
              )
            }
          }
          this.signerList = res.dto.historic;
        }
    },
    (error) => {
      console.log('get document error')
      this.router.navigateByUrl('page-not-found');
    })
  }

  downloadFile() {
    this.signatureService.download(this.uidSigned, 'signed').subscribe((res: Any) => {
      const link = document.createElement("a");
      link.href = `data:application/pdf;base64,${res.dto}`;
      var date = new Date();
      link.download = date.getTime() + '_' + 'signature.pdf'
      link.click();
    })
  }

  openModal() {

    if (this.subscriber) {
      const modalRef = this.modalService.open(SignUpModalComponent, { centered: true });
      modalRef.componentInstance.signupInformations = {
        uidDoc: this.uidDoc,
        uidSigner: this.uidSigner,
        signer: this.subscriber,
      };
      modalRef.result.then(res => {
        console.log(res)
      });
    }
  }

  showFormMobile() {
    let signerTemp = this.signerList.filter(user => user.email === this.subscriber?.email)[0]

    if(signerTemp.type === '4') {
      signerTemp.type = 'Parte';
    }
    if(signerTemp.type === '5') {
      signerTemp.type = 'Testemunha';          
    }

    this.valueFormMobile = {
      uidDoc: this.uidDoc,
      uidSigner: this.uidSigner,
      signer: signerTemp,
    };

    this.mobileShowSignForm = true
  }

  prepareDownload(type) {
    let downloadId
    if(type === 'signed') {
      downloadId = this.uidSigned
    } else {
      downloadId = this.uidDoc
    }
    this.signatureService.download(downloadId, type).subscribe(
      res => {
        this.download(res.dto, this.documentName)
      }
    )
  }

  download(fileUrl, fileName) {
    var a = document.createElement("a");
    a.href = fileUrl;
    a.setAttribute("download", fileName);
    a.setAttribute("target", "blank");
    a.click();
  }
}
